import React, { useState, useRef, useEffect } from "react";
import { Drawer } from "antd";
import { FaChevronDown, FaChevronLeft } from "react-icons/fa";
import { IoClose } from "react-icons/io5";

// components
import Button from "@/shared/Button";
import MoreFiltersForm from "@/components/Form/MoreFiltersForm";
import { TMoreFiltersRefMethods } from "@/components/Form/MoreFiltersForm/IMoreFiltersForm";

// helpers
import { useDimension } from "@/hooks/useDimensions";

// interface
import { ICurrency } from "@/types/api/Currency";
import { IFacets } from "@/types/api/Facets";

// assets
import styles from "@/assets/styles/pages/search-results/search-results-fIlter-drawer.module.scss";


interface ISearchResultsFilterDrawer {
  currency: ICurrency;
  currentQuery: Record<string, unknown>;
  facets: IFacets;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

function SearchResultsFilterDrawer({ currency, facets, open, onOpenChange } : ISearchResultsFilterDrawer) {
  const [isOpen, setIsOpen] = useState(false);
  const [isShowClear, setIsShowClear] = useState(false);

  const [width] = useDimension();
  const ref = useRef<TMoreFiltersRefMethods | null>(null);

  // methods
  const handleOpenChange = (e: boolean) => {
    setIsOpen(e);
    onOpenChange(e);
  }

  const handleClearFilters = () => {
    if (ref.current && ref.current.clearFilters) {
      ref.current.clearFilters();
    }
  };

  // effects
  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  // renders

  return (
    <div className={`${styles["locl-search-results-filter-drawer"]} ${isOpen ? styles["locl-search-results-filter-drawer_active"] : ""}`}>
      {
        !isOpen && (
          <div className={styles["locl-search-results-filter-drawer__preview"]}>
            <Button
              iconRight={<FaChevronDown/>}
              onClick={() => handleOpenChange(true)}
              className={styles["locl-search-results-filter-drawer__preview__button"]}
              data-testid="locl-search-more-filters-button-filters"
            >
              Advanced filters
            </Button>
          </div>
        )
      }
      <Drawer
        getContainer={(width < 1200) ? "body" : false}
        open={isOpen}
        rootClassName={styles["locl-search-results-filter-drawer__inner"]}
        placement="left"
        title={<>
          <span className={styles["locl-search-results-filter-drawer__inner-title"]}>Advanced filters</span>
          {
            isShowClear && (
              <Button
                type="tertiary"
                danger
                onClick={handleClearFilters}
              >
                Clear filters
              </Button>
            )
          }
          <Button
            className={styles["locl-search-results-filter-drawer__inner__close"]}
            icon={width < 1200 ? <IoClose/> : <FaChevronLeft/>}
            type="secondary"
            size="small"
            data-testid="locl-search-results-filter-drawer-inner-close"
            onClick={() => handleOpenChange(false)}
          />
        </>}
      >
        <MoreFiltersForm
          ref={ref}
          open={isOpen}
          currency={currency}
          facets={facets}
          setIsShowClear={setIsShowClear}
          isShowSearchFilter={width < 1200}
        />
      </Drawer>
    </div>
  );
}

export default SearchResultsFilterDrawer;

